import axios from 'axios';
import { useQuery } from 'react-query';

import config from '../config';

// apis
const fetchFileTypes = () => axios.get(
  `${config.apiHost}${config.endpoints.fileTypes}`,
  { withCredentials: true }
);


// queries
export const useFileTypesData = () => 
  useQuery('fileTypes', fetchFileTypes, {
    staleTime: Infinity,
  });




// WEBPACK FOOTER //
// ./src/hooks/useFileTypesData.js